export default __webpack_public_path__ + "static/media/UOB_Travel_Home.2251ccae.png";